import React, { Dispatch, useEffect } from 'react';
import { KioskStateType, Reducer, InitialState } from './KioskReducer';
import { ActionType } from './Actions';
import loadFromStorage from '../utils/loadStateFromLocalStorage';

const StateContext = React.createContext<KioskStateType | undefined>(undefined);
const DispatchContext = React.createContext<Dispatch<ActionType> | undefined>(
  undefined
);

export default function KioskProvider(props: React.PropsWithChildren<{}>) {
  const [state, dispatch] = React.useReducer<
    React.Reducer<KioskStateType, ActionType>
  >(Reducer, InitialState);

  // Load the stored state once at launch
  useEffect(() => {
    loadFromStorage(dispatch);
  }, []);

  return (
    <StateContext.Provider value={state}>
      <DispatchContext.Provider value={dispatch} {...props} />
    </StateContext.Provider>
  );
}

export { StateContext, DispatchContext };
